import { getLogger } from '../lib/logging/core'

export const logger = getLogger()
